import {AbstractService} from 'services/AbstractService';

const BRANDS_LIST_URL = '/api/brands';

export class BrandsService extends AbstractService {

  list (accountId) {
    return this.client.get(BRANDS_LIST_URL, {}, {accountId});
  }

}
